import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { addQueryArgs } from '@wordpress/url';
import apiFetch from '@wordpress/api-fetch';
import interpolateComponents from 'interpolate-components';
/**
 * Internal dependencies
 */

import { computeSuggestionMatch } from './utils';
/**
 * A coupon completer.
 * See https://github.com/WordPress/gutenberg/tree/master/packages/components/src/autocomplete#the-completer-interface
 *
 * @type {Completer}
 */

export default {
  name: 'coupons',
  className: 'woocommerce-search__coupon-result',
  options: function options(search) {
    var query = search ? {
      search: search,
      per_page: 10
    } : {};
    return apiFetch({
      path: addQueryArgs('/wc-analytics/coupons', query)
    });
  },
  isDebounced: true,
  getOptionIdentifier: function getOptionIdentifier(coupon) {
    return coupon.id;
  },
  getOptionKeywords: function getOptionKeywords(coupon) {
    return [coupon.code];
  },
  getFreeTextOptions: function getFreeTextOptions(query) {
    var label = createElement("span", {
      key: "name",
      className: "woocommerce-search__result-name"
    }, interpolateComponents({
      mixedString: __('All coupons with codes that include {{query /}}', 'woocommerce-admin'),
      components: {
        query: createElement("strong", {
          className: "components-form-token-field__suggestion-match"
        }, query)
      }
    }));
    var codeOption = {
      key: 'code',
      label: label,
      value: {
        id: query,
        code: query
      }
    };
    return [codeOption];
  },
  getOptionLabel: function getOptionLabel(coupon, query) {
    var match = computeSuggestionMatch(coupon.code, query) || {};
    return createElement("span", {
      key: "name",
      className: "woocommerce-search__result-name",
      "aria-label": coupon.code
    }, match.suggestionBeforeMatch, createElement("strong", {
      className: "components-form-token-field__suggestion-match"
    }, match.suggestionMatch), match.suggestionAfterMatch);
  },
  // This is slightly different than gutenberg/Autocomplete, we don't support different methods
  // of replace/insertion, so we can just return the value.
  getOptionCompletion: function getOptionCompletion(coupon) {
    var value = {
      key: coupon.id,
      label: coupon.code
    };
    return value;
  }
};
//# sourceMappingURL=coupons.js.map